import { Link } from 'react-router-dom';
import { Clickable, hexToRgba, mq, backgroundGradient } from '@phishtool/ui';
import styled from 'styled-components';
export const StyledHeader = styled.header.withConfig({ displayName: "StyledHeader", componentId: "sc-1cuuy3g" }) `
  ${backgroundGradient}

  ${(props) => mq({
    padding: [`${props.theme.spacers.x3} 0`, null, `${props.theme.spacers.x6} 0`],
})}
`;
export const StyledLogoLink = styled(Link).withConfig({ displayName: "StyledLogoLink", componentId: "sc-13mw5tf" }) `
  display: flex;
`;
export const StyledNav = styled.nav.withConfig({ displayName: "StyledNav", componentId: "sc-1cp0j3d" }) `
  top: 0;
  right: 0;
  transition: opacity 250ms;

  ${(props) => mq({
    background: [hexToRgba(props.theme.colors.darkEclipse, 0.95), null, 'transparent'],
    position: ['fixed', null, 'static'],
    width: ['50%', null, 'auto'],
    height: ['100%', null, 'auto'],
    opacity: [props.isOpen ? 1 : 0, null, 1],
    zIndex: [props.isOpen ? 2 : -1, null, 1],
})}
`;
export const StyledHamburgerWrapper = styled.div.withConfig({ displayName: "StyledHamburgerWrapper", componentId: "sc-16y02af" }) `
  justify-content: flex-end;
  align-items: center;
  height: 100%;

  ${mq({
    display: ['flex', null, 'none'],
})}
`;
export const StyledHamburger = styled(Clickable).withConfig({ displayName: "StyledHamburger", componentId: "sc-3f5wtt" }) `
  width: 22px;
  height: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const StyledHamburgerLine = styled.span.withConfig({ displayName: "StyledHamburgerLine", componentId: "sc-1yme4qr" }) `
  width: 100%;
  height: 2px;
  background: ${(props) => props.theme.colors.white};
`;
export const StyledCloseButtonWrapper = styled.div.withConfig({ displayName: "StyledCloseButtonWrapper", componentId: "sc-17u4t9k" }) `
  justify-content: flex-end;
  align-items: center;
  height: 18px;
  z-index: 3;
  position: fixed;

  ${mq({
    display: ['flex', null, 'none'],
})}
`;
export const StyledCloseButton = styled(Clickable).withConfig({ displayName: "StyledCloseButton", componentId: "sc-nuv51q" }) `
  width: 18px;
  height: 18px;
  position: relative;

  &:before,
  &:after {
    position: absolute;
    left: 8px;
    content: ' ';
    height: 22px;
    width: 2px;
    background: ${(props) => props.theme.colors.white};
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;
export const StyledNavList = styled.ul.withConfig({ displayName: "StyledNavList", componentId: "sc-1w2cjoh" }) `
  display: flex;
  justify-content: flex-end;
  gap: ${(props) => props.theme.spacers.x3};
  padding: 0;
  margin: 0;
  list-style: none;

  ${(props) => mq({
    flexDirection: ['column', null, 'row'],
    paddingTop: [props.theme.spacers.x9, null, 0],
    paddingLeft: [props.theme.spacers.x5, null, 0],
})}
`;
export const StyledNavListItem = styled.li.withConfig({ displayName: "StyledNavListItem", componentId: "sc-1jxi14q" }) ``;
export const StyledNavItem = styled.a.withConfig({ displayName: "StyledNavItem", componentId: "sc-1oah10m" }) `
  ${(props) => props.theme.responsiveFontsize.body.medium}
  font-weight: ${(props) => props.theme.fontWeights.medium};
  text-decoration: ${(props) => (props.isActive ? 'underline' : 'none')};
  text-underline-offset: 10px;
  color: ${(props) => props.theme.colors.white};

  &:hover {
    text-decoration: underline;
  }
`;
export const StyledNavButton = styled.a.withConfig({ displayName: "StyledNavButton", componentId: "sc-181ym26" }) `
  ${(props) => props.theme.responsiveFontsize.body.medium}
  font-weight: ${(props) => props.theme.fontWeights.medium};
  text-decoration: none;
  color: ${(props) => props.theme.colors.white};
  padding: ${(props) => props.theme.spacers.x1} ${(props) => props.theme.spacers.x2};
  border-radius: ${(props) => props.theme.radii.primary};
  border: 1px solid ${(props) => props.theme.colors.white};

  &:hover {
    background: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.celticBlue};
  }

  ${() => mq({
    display: ['inline-block', null, 'inline'],
})}
`;
